export const convertToKiloBytes = (storageSize: string) => {
  /* eslint-disable react/destructuring-assignment */
  const formattedSizeString = storageSize.toUpperCase();

  if (formattedSizeString.includes('KB')) {
    return Number(formattedSizeString.split('KB')[0]) * 1;
  }
  if (formattedSizeString.includes('MB')) {
    return Number(formattedSizeString.split('MB')[0]) * 1024;
  }
  if (formattedSizeString.includes('GB')) {
    return Number(formattedSizeString.split('GB')[0]) * 1048576;
  }
  if (formattedSizeString.includes('TB')) {
    return Number(formattedSizeString.split('TB')[0]) * 1073741824;
  }
  return null;
};
